import queryString from 'query-string';

const queryParameters = queryString.parse(window.location.search, { parseBooleans: true });

export default queryParameters;
